import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import NorthEastIcon from '@mui/icons-material/NorthEast';

const ClockingTimes = ({ ClockingTimes}) => {
  return (
    <div className="w-full mx-auto min-h-[450px]">
      <div className="rounded-[12.75px]  border border-black/10 bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),_0px_1px_2px_-1px_rgba(0,0,0,0.10)] p-6 pb-8">
        {/* Header */}
        <div className="flex flex-col items-start gap-1 mb-4 text-left">
          <div className='flex gap-1'>

              <AccessAlarmIcon />
          <div className="text-xl font-semibold">Clocking Times</div>
          </div>
        
      
            
            <div className="text-sm text-[#717182] ">
              Today's clocking time summary
            </div>
         
        </div>

        {/* Clock-in / Clock-out Cards */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          {/* Clock-in Card */}
          <div
            className="relative p-4 flex-1"
            style={{
              borderRadius: '12.75px',
              border: '1px solid rgba(0, 0, 0, 0.10)',
              background: '#FEF2F2',
              boxShadow:
                '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)',
              minHeight: '90px',
            }}
          >
            <div className="absolute top-3 right-3 p-2">
              <SouthEastIcon style={{ color: '#432DD7' }} />
            </div>
            <div className="text-[#432DD7] text-sm font-semibold text-left">Clock-in</div>
            <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">{ClockingTimes?.median_clockin||'-'}</div>
            <div className="text-[#717182] text-sm mt-1 text-left">Average arrival time</div>
          </div>

          {/* Clock-out Card */}
          <div
            className="relative p-4 flex-1"
            style={{
              borderRadius: '12.75px',
              border: '1px solid rgba(0, 0, 0, 0.10)',
              background: '#FEF2F2',
              boxShadow:
                '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)',
              minHeight: '90px',
           
            }}
          >
            <div className="absolute top-3 right-3 p-2">
              <NorthEastIcon style={{ color: '#432DD7' }} />
            </div>
            <div className="text-[#432DD7] text-sm font-semibold text-left">Clock-out</div>
            <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">{ClockingTimes?.median_clockout||'-'}</div>
            <div className="text-[#717182] text-sm mt-1 text-left">Average departure time</div>
          </div>
        </div>

        {/* Info Rows */}
        <div className="border-t border-black/10">
          {/* Row 1 */}
          <div className="flex justify-between items-center py-3 border-b border-black/10">
            <span className="text-sm text-[#717182]">Earliest Clock-in</span>
            <span className="text-sm text-[#0A0A0A]">{ClockingTimes?.earliest_clockin||'-'}</span>
          </div>
          {/* Row 2 */}
          <div className="flex justify-between items-center py-3 border-b border-black/10">
            <span className="text-sm text-[#717182]">Latest Clock-in</span>
            <span className="text-sm text-[#0A0A0A]">{ClockingTimes?.latest_clockin||'-'}</span>
          </div>
          {/* Row 3 - Special style */}
          <div
            className="flex justify-between items-center py-3 px-2 mt-2"
         
          >
            <span className="text-sm text-[#717182]">Missed Punches</span>
            <span className="text-sm font-semibold text-[#C10007] bg-[#FEF2F2] px-2 rounded-full">{ClockingTimes?.missed_punches||'-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClockingTimes;
